import { Icon, type IconTone } from './Icon';

/** Паспорт питомца: карточка с записью. */
export function PassportIcon({ size, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} tone={tone}>
      <rect x="1.4" y="1.4" width="11.2" height="11.2" />
      <path d="M4 7 h6" />
    </Icon>
  );
}
